(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfErrorsContainer', function() {
    return {
      restrict: 'E',
      link: (function(_this) {
        return function(scope, element, attrs, ctrl) {
          element.addClass('errorDiv');
          return element.show();
        };
      })(this),
      controller: (function(_this) {
        return function() {
          return void 0;
        };
      })(this)
    };
  });

}).call(this);
